module.exports = __webpack_public_path__ + "static/media/left-arrow.29e27bb0.svg";